import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProductService } from '@app/core/business/product/product.service';
import { ContextService } from '@app/core/service/context.service';


@UntilDestroy()
@Component({
  selector: 'app-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.scss']
})
export class ScanComponent implements OnInit, OnDestroy {
   isProcessing = false;

  constructor(
    private productService: ProductService,
    private contextService: ContextService,
    private router: Router
  ) {}

  ngOnInit(): void {  }

  ngOnDestroy(): void { }

  handleProductLookup(code: string): void {
    const ctx = this.contextService.context;
    if (!ctx.customerCode) {
      alert('Client requis');
      return;
    }

    this.isProcessing = true;
    this.productService.getScanProduct(code, ctx.companyCode, ctx.customerCode, ctx.orderCode)
      .subscribe({
        next: (p) => {
          this.isProcessing = false;
          if (p?.code) this.router.navigate(['/product', p.code]);
        },
        error: () => {
          this.isProcessing = false;
          alert('Erreur produit');
        }
      });
  }

  goBack(): void {
    this.router.navigate(['/']);
  }
}